<div id="addWidgetContainer" *ngIf="showWidgets()">
    <div class="slidedown">
        <div class="position-relative float-left add-widget-menu collapsible" [ngClass]="{'add-widget-menu-index': showPreview}">
                <div class="row no-gutters horizontalscroller">
                    <div class="nav-tabs groupTabs ">
                        <!--Group Tabs-->
                        <div class="group-tabs-container" [hidden]="filterText.length > 0">
                            <ul class="nav-tabs" style="padding: 1px;">
                                <li class="nav-item module-nav-tabs" *ngFor="let moduleGroup of filteredGroups; let i = index" [ngClass]="{
                                    'acd-color':acdTab === widgetGroupName(moduleGroup.icon), 
                                    'qm-color':qmTab === widgetGroupName(moduleGroup.icon), 
                                    'analytics-color':analyticsTab === widgetGroupName(moduleGroup.icon), 
                                    'metrics-color':metricsTab === widgetGroupName(moduleGroup.icon), 
                                    'coaching-color':coachingTab === widgetGroupName(moduleGroup.icon), 
                                    'pm-color':pmTab === widgetGroupName(moduleGroup.icon)}">

                                    <a class="nav-link" (click)="activeTab= i;" [ngClass]="{'active':activeTab === i, 
                                        'acd-color':acdTab === widgetGroupName(moduleGroup.icon), 
                                        'qm-color':qmTab === widgetGroupName(moduleGroup.icon), 
                                        'analytics-color':analyticsTab === widgetGroupName(moduleGroup.icon), 
                                        'metrics-color':metricsTab === widgetGroupName(moduleGroup.icon),
                                        'coaching-color':coachingTab === widgetGroupName(moduleGroup.icon),
                                        'pm-color':pmTab === widgetGroupName(moduleGroup.icon)}">
                                        <svg class="moduleGroupIcon" *ngIf="moduleGroup.icon" style="margin: 4px 4px 3px;">
                                            <use [attr.href]="getWidgetGroupSvgPath(moduleGroup.icon)"></use>
                                        </svg>
                                        {{moduleGroup.localizedGroup}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="flex-fill"></div>
                        <div class="col-3 justify-content-end cxone-live-search">
                        <!--Search-->
                        <cxone-text-input 
                            id="widgetSearch"
                            type="search" 
                            autocomplete="off" 
                            placeholder="{{placeholder}}" 
                            class="add-widget-search"
                            [(ngModel)]="this.filterText">
                        </cxone-text-input>
                        <i class="icon-search" [hidden]="filterText.length !== 0">
                            <svg class="icon-20 fill-iconDefault-noHover search-wrapper">
                                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                            </svg>
                        </i>
                        <i class="icon-search" [hidden]="filterText.length === 0" (click)="filterText = ''">
                            <svg class="icon-20 fill-iconDefault-noHover close-wrapper">
                                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                            </svg>
                        </i>
                        <div style="margin-top: 5px;">
                            <button type="button" (click)="closeAddWidget.emit()" class="icon-btn fill-iconDefault closeWidgets">
                                <svg class="icon-12">
                                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                                </svg>
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
                <!--List of modules - grouped-->
                <div class="w-100">
                <div class="widgets-wrapper" [ngClass]="{'show active':activeTab === i}" [hidden]="activeTab !== i || filterText.length > 0"
                     *ngFor="let moduleGroup of filteredGroups; let i = index" #shownWrapper>
                    <ul class="widget-list">
                        <li [id]="'widgetItem-' + module.ModuleID" class="widget-item" *ngFor="let module of moduleGroup.modules | filterText: filterText : 'LocalizedName'"
                            (click)="this.widgetClicked(module)">
                            <div class="widget-card" 
                                [attr.id]="'widgetCard-' + module.ModuleID" 
                                [placement]="['bottom', 'bottom-left', 'bottom-right']" 
                                [ngbTooltip]="modulePreview" 
                                #preview="ngbTooltip"
                                tooltipClass="module-preview" 
                                container="body"
                                [attr.draggable]="!navigationService.addingModule && !navigationService.showOverlay"
                                (dragstart)="this.onDragStart($event, module); preview.close();"
                                (dragend)="this.onDragEnd($event, module)"
                                (mouseover)="hoverIn(module, $event);" 
                                (mouseleave)="hoverOut()">
                                <svg class="widget-icon"><use [attr.href]="iconPath + getWidgetIcon(module)" ></use></svg>
                            </div>
                            <div class="widget-name">        
                                <span>{{module.LocalizedName}}</span>                    
                            </div>
                        </li>
                    </ul>
                </div>
                </div>
                <!--List of modules - not grouped - shown when searching modules-->
                <div id="widgetsWrapper-Search" class="widgets-wrapper" *ngIf="filterText.length > 0">
                    <ul id="widgetList-Search" class="widget-list">
                        <li id="widgetItem-Search" class="widget-item" #filteredModules
                            *ngFor="let module of navigationService.modules | filterText: filterText : 'LocalizedName'"
                            (click)="this.widgetClicked(module)">
                            <div class="widget-card" 
                                [attr.id]="'widgetCard-' + module.ModuleID" 
                                [ngbTooltip]="modulePreview"
                                #preview="ngbTooltip"
                                tooltipClass="module-preview" 
                                [placement]="['bottom', 'bottom-left', 'bottom-right']" 
                                container="body" 
                                [attr.draggable]="!navigationService.addingModule && !navigationService.showOverlay"
                                (dragstart)="this.onDragStart($event, module); preview.close();"
                                (dragend)="this.onDragEnd($event, module)" 
                                (mouseleave)="hoverOut()" 
                                (mouseover)="hoverIn(module, $event)">
                                <svg class="widget-icon"><use [attr.href]="iconPath + getWidgetIcon(module)"></use></svg>
                            </div>
                            <span class="widget-name" [innerHTML]="module.LocalizedName | boldText:filterText:2"></span>
                        </li>
                    </ul>
                </div>
                <!-- Module Preview - Used for both Grouped and Not Grouped modules -->
                <ng-template #modulePreview  class="">
                    <module-preview class="modulePreviewDir"
                                    [module]="currentModule"
                                    [hoverIndex]="hoverIndex"
                                    [continueShow]="continueShow"
                                    [currentModuleid]="currentModule.ModuleID"
                                    [isAddModuleDropdown]="isAddModuleDropdown"
                                    [ModuleGroup]="ModuleGroup"
                                    [isSearch]="filterText.length > 0">
                    </module-preview>
                </ng-template>
        </div>
    </div>
</div>
